import ppe from "./ppe";
import ziggo from "./ziggo";

import ThemeInterface from "types/ThemeInterface";

export const themeCollection: { [value: string]: ThemeInterface } = { ppe: ppe, ziggo: ziggo };
